<div class="legend-title" [style.margin-bottom]="titleBodyDistance + 'px'">
  <div class="legend-title-text">
    {{ title }}
  </div>
</div>
<div class="legend-body">
  <ng-content></ng-content>
</div>
